// extracted by mini-css-extract-plugin
module.exports = {"features":"InfoBoxBlock_features__3PLGz","feature":"InfoBoxBlock_feature__3n5dQ","featureIcon":"InfoBoxBlock_featureIcon__2mSMX","featureText":"InfoBoxBlock_featureText__1xIjF"};